// extracted by mini-css-extract-plugin
module.exports = {"base":"BuyButton_base__1SCFT","btn":"BuyButton_btn__OX2dl","card":"BuyButton_card__10E52","originalPrice":"BuyButton_originalPrice__1xdGP","overlay":"BuyButton_overlay__X2KHj"};